export const isPresent = (value: unknown): boolean =>
  value !== null
  && value !== undefined
  && (typeof value !== 'number' || Number.isFinite(value));

export const resolveAnchor = (el: HTMLElement): HTMLAnchorElement | null =>
  el instanceof HTMLAnchorElement ? el : el.querySelector<HTMLAnchorElement>('a');
